import ChatModule from './ChatModule';

export default ChatModule;
